import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Package,
  Eye
} from 'lucide-react';

const ScheduleActions = ({ 
  schedule, 
  statusInfo, 
  handleMarkReady, 
  setSelectedSchedule, 
  updateStatusMutation,
  compact = false
}) => {
  const { t } = useTranslation();

  if (compact) {
    return (
      <div className="flex gap-2">
        {statusInfo.canMarkReady && (
          <button
            onClick={() => handleMarkReady(schedule)}
            disabled={updateStatusMutation.isLoading}
            className="flex-1 flex items-center justify-center gap-1 bg-green-600 text-white px-3 py-1.5 rounded-md hover:bg-green-700 disabled:opacity-50 transition-colors text-xs"
          >
            <Package className="w-3 h-3" />
            {updateStatusMutation.isLoading ? 
              t('updating', 'Updating...') : 
              t('markReady', 'Mark Ready')
            }
          </button>
        )}

        <button
          onClick={() => setSelectedSchedule(schedule)}
          className="flex-1 flex items-center justify-center gap-1 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-200 transition-colors text-xs"
        >
          <Eye className="w-3 h-3" />
          {t('viewDetails', 'View Details')}
        </button>
      </div>
    );
  }

  return (
    <div className="lg:w-48 space-y-3">
      {statusInfo.canMarkReady && (
        <button
          onClick={() => handleMarkReady(schedule)}
          disabled={updateStatusMutation.isLoading}
          className="w-full flex items-center justify-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors"
        >
          <Package className="w-4 h-4" />
          {updateStatusMutation.isLoading ? 
            t('updating', 'Updating...') : 
            t('markReady', 'Mark Ready')
          }
        </button>
      )}

      <button
        onClick={() => setSelectedSchedule(schedule)}
        className="w-full flex items-center justify-center gap-2 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
      >
        <Eye className="w-4 h-4" />
        {t('viewDetails', 'View Details')}
      </button>
    </div>
  );
};

export default ScheduleActions;
